import { sections } from 'config'
import { Parameters } from 'types'
import en from 'languages/en'
import ru from 'languages/ru'

export const chooseColor = (code: string) =>
  sections.find((s) => code === s.code)?.color

export const buildProgramData = (data: { values: Array<string[]>}) => {
  const dataCopy = data.values.slice();
  const columnNames = dataCopy.shift() as string[]

  /*const programs = dataCopy.map((row, rowIndex) =>
    columnNames[rowIndex]
  )*/
  en.about[0].id=dataCopy.length+1;
  en.about[1].id=dataCopy.length+2;
  en.about[2].id=dataCopy.length+3;
  en.about[3].id=dataCopy.length+4;
  ru.about[0].id=dataCopy.length+1;
  ru.about[1].id=dataCopy.length+2;
  ru.about[2].id=dataCopy.length+3;
  ru.about[3].id=dataCopy.length+4;

  const programs = dataCopy.map((row, rowIndex) =>
      row.reduce(
      (acc, value, index) => {
        const columnName = columnNames[index] as string

        return {
          ...acc,
          [columnName]: columnName=="id"?rowIndex+1:value,
        }
      },
      { id: rowIndex + 1 } as Parameters
    )
  )
  return programs
}
